import { useEffect } from 'react';

import { event } from '@hotjar/webapp/tracking/tools/hotjar';

export const RECORDING_HIGHLIGHT_VIEWED = 'recording_highlight_viewed';

export const HEATMAP_HIGHLIGHT_VIEWED = 'heatmap_highlight_viewed';

export function useViewTracking(highlight: {
  status: 'success' | unknown;
  data: undefined | { type: 'heatmap' | 'recording' | unknown };
}): void {
  useEffect(() => {
    if (highlight.status !== 'success') {
      return;
    }

    if (highlight.data?.type === 'heatmap') {
      event(HEATMAP_HIGHLIGHT_VIEWED);
    } else if (highlight.data?.type === 'recording') {
      event(RECORDING_HIGHLIGHT_VIEWED);
    }
  }, [highlight.status, highlight.data]);
}
